import {
  AngleLeft,
  ChakraButton,
  ChakraFlex,
  ChakraText,
  EquipUIFireflyV2Theme,
  EquipUITheme,
} from '@equip.health/ui';

const { neutral } = EquipUIFireflyV2Theme.colors;
const { h6, labelBold } = EquipUITheme.typography;

type TaskNotFoundProps = {
  handleBackClick: () => void;
};

const TaskNotFound = ({ handleBackClick }: TaskNotFoundProps) => (
  <>
    <ChakraText
      {...h6}
      justifyContent="center"
      padding="16px"
      textAlign="center"
      width="100%"
    >
      Task not found
    </ChakraText>
    <ChakraFlex justifyContent="center">
      <ChakraButton
        {...labelBold}
        color="neutral.secondary"
        display="flex"
        leftIcon={
          <AngleLeft fill={neutral.secondary} height="15px" width="15px" />
        }
        lineHeight="16.8px"
        onClick={handleBackClick}
        variant="link"
      >
        Return to tasks
      </ChakraButton>
    </ChakraFlex>
  </>
);

export default TaskNotFound;
